import React from 'react';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { getAuth0Tenant } from '@client';
import { useAuthorizationParams } from '@client/hooks/useAuthorizationParams';

export const ConfigurableAuth0Provider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const { authorizationParams, searchParams } = useAuthorizationParams();
  const { priceId, clientSignIn } = searchParams;

  const onRedirectCallback = (appState: AppState | undefined) => {
    let redirectUrl =
      (appState && appState.returnTo) ||
      window.location.pathname + window.location.search;

    if (appState?.returnTo && appState.returnTo.includes('client_sign_in=')) {
      try {
        const url = new URL(appState.returnTo, window.location.origin);
        redirectUrl = url.pathname + url.search; // Preserve query params
      } catch (e) {
        console.error('Failed to parse returnTo URL:', e);
      }
    }

    navigate(redirectUrl);
  };

  const { domain, clientId } = getAuth0Tenant();
  const authParamsKey = [clientSignIn, priceId].join('|');
  return (
    <Auth0Provider
      key={authParamsKey}
      onRedirectCallback={onRedirectCallback}
      skipRedirectCallback={
        window.location.pathname === '/oauth/google/callback' ||
        window.location.pathname === '/oauth/microsoft/callback'
      }
      domain={domain}
      clientId={clientId}
      authorizationParams={authorizationParams}
      useRefreshTokens
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};
